import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-685b67e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = { alt: "" }
const _hoisted_4 = { class: "bottom" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: "seckill-goods",
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.unifiedJump($props.data)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
        [_directive_lazy, _ctx.webpFilters($props.data.goods.images.L)]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(parseInt($props.data.price).thousands()), 1),
      ($props.data.goods.price_market)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(parseInt($props.data.goods.price_market).thousands()), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(parseInt($props.data.goods.goods_marketprice).thousands()), 1))
    ])
  ]))
}